import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class PlanningAllocationResourcesSelectionTableCtrl implements IController {

  resources: any;
  selectedIds: any;
  disableIds: any;
  queryString: any;
  onToggle: Function;
  onToggleAll: Function;

  /* @ngInject */
  constructor(private $filter) {
  }

  $onInit() {
    if (!this.selectedIds) {
      this.selectedIds = [];
    }
  }

  getFilteredResources() {
    if (!this.queryString || !this.resources) {
      return this.resources || [];
    }
    return this.$filter('filter')(this.resources, this.queryString);
  }

  areAllFilteredSelected() {
    const filteredResources = this.getFilteredResources();
    if (!filteredResources || filteredResources.length === 0) {
      return false;
    }
    return filteredResources.every(resource => _.includes(this.selectedIds, resource.id));
  }

  areSomeFilteredSelected() {
    const filteredResources = this.getFilteredResources();
    if (!filteredResources || filteredResources.length === 0) {
      return false;
    }
    const selectedCount = filteredResources.filter(resource => _.includes(this.selectedIds, resource.id)).length;
    return selectedCount > 0 && selectedCount < filteredResources.length;
  }

  isSelectedResource(resource) {
    return _.includes(this.selectedIds, resource.id);
  }

  isOptionDisabled(resource) {
    return _.includes(this.disableIds, resource.id);
  }

}


angular
  .module('bringoz.admin.planning')
  .component('planningAllocationResourcesSelectionTable', {
    bindings: {
      resources: '<',
      selectedIds: '<?',
      disableIds: '<?',
      queryString: '<?',
      onToggle: '&',
      onToggleAll: '&'
    },
    templateUrl: 'app/modules/planning/components/planning-allocation-resources-selection-table/planning-allocation-resources-selection-table.html',
    controller: PlanningAllocationResourcesSelectionTableCtrl
  });
